import type { Site } from './Site';

export const defaultSite: Site = {
  // TODO(Petr): HAWK-7560 Change to 'default'?
  id: 'hawk',
  logo: '',
  label: '',
  // TODO(Petr): HAWK-7560 Change to 'default'?
  analyticsName: 'hawk',
  platform: '',
  selector: 'a',
};
